export const TurnkeyErrorCodes = {
    UserLoggedOut: 7,
};
